
import Vue, { PropType } from 'vue'
import MenuEntity, { IMenuProps } from '@/entities/Menu'
import UnreadEntity from '@/entities/Unread'

const component = Vue.extend({
  props: {
    value: {
      type: Object as PropType<IMenuProps>,
      default: null
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    unread() {
      if (this.value.id === null) return 0
      return new UnreadEntity(this.App.notification.unread).unread(this.value.id)
    }
  },
  methods: {
    m(value?: IMenuProps): MenuEntity {
      return new MenuEntity(value)
    },
    click(value: IMenuProps) {
      if (this.m(value).href) {
        window.open(this.m(value).href, this.m(value).target)
      } else {
        this.$router.push(this.m(value).to)
      }
    }
  }
})
Vue.component('AMenuSubItem', component)
export default component
